import { MdsIcon } from "@/design-system/components/icon";
import { IMDSButtonIconProps } from "@/mds/components/buttons/button/button.types";
import styled from "@emotion/styled";

export const MDSButtonIcon = ({ slot, ...props }: IMDSButtonIconProps) => {
  return (
    <StyledIconWrapper slot={slot}>
      <MdsIcon {...props} />
    </StyledIconWrapper>
  );
};

const StyledIconWrapper = styled.div`
  height: 16px;
`;
